import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys, helpers } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

//////////////////
// CALENDAR PROFILE
//////////////////
const relativeWrapper: CSSProperties = {
  position: "relative",
  height: "100%",
};

const container: CSSProperties = {
  position: "relative",
  marginBottom: spacing.lg,
};

const gatedContainer: CSSProperties = {
  position: "absolute",
  height: "100%",
  width: "calc(100% + 10px)",
  top: 0,
  left: -10,
  zIndex: 1,
  background: `linear-gradient(180deg, ${greys.white}, ${helpers.opacity(greys.white, 0.25)})`,
  padding: "15px 10px 0px",
};

const gatedMessage: CSSProperties = {
  paddingTop: 10,
  textAlign: "center",
  fontSize: 14,
  color: greys.slate,
  fontWeight: 600,
  lineHeight: 1.5,
};

const hideOverflow: CSSProperties = {
  overflow: "hidden",
};

const blur: CSSProperties = {
  webkitFilter: "blur(3px)",
  filter: "blur(3px)",
};

const inviteButton: CSSProperties = {
  marginTop: 15,
  boxShadow: "none",
};

export const buttonIcon = {
  style: {
    marginRight: 7,
  } as CSSProperties,
  htmlColor: greys.white,
};

const loading: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  position: "absolute",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 300,
};

const divider: CSSProperties = {
  marginBottom: spacing.std,
  marginTop: spacing.std,
};

const warning: CSSProperties = {
  marginTop: spacing.lg,
};

const pickerContainer: CSSProperties = {
  marginTop: spacing.std,
  marginBottom: spacing.std,
};

const title: CSSProperties = {
  marginBottom: spacing.std,
  color: colors.blueDusk.standard,
};

export const styles = {
  relativeWrapper,
  container,
  gatedContainer,
  gatedMessage,
  hideOverflow,
  blur,
  inviteButton,
  loading,
  divider,
  warning,
  pickerContainer,
  title,
};
